import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

// components
import {
  CContainer,
  CCol,
  CRow,
  CBadge
} from '@coreui/react-pro'
import FormDatePicker from '../../components/form/general-input-form/FormDatePicker'
import FormSelectInput from '../../components/form/general-input-form/FormSelectInput'
import AppTable from 'src/components/AppTable'

// helpers
import Axios from '../../helpers/axios'
import { singleClientsOptionsSelect, singlePeriodOptionSelect } from '../../helpers/format-options'
import { convertMoney } from '../../helpers/format-number'
import { formUrlQuery } from '../../helpers/format-queries'
import { columnCashflowPositionList, columnProjectList } from '../../components/table-column/TableColumnList'

const Dashboard = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [dashboardCount, setDashboardCount] = useState(null);
  const [clientOptions, setClientOptions] = useState([])

  const [startDateValue, setStartDateValue] = useState(null)
  const [endDateValue, setEndDateValue] = useState(null)
  const [clientValue, setClientValue] = useState(null)
  const [periodValue, setPeriodValue] = useState(null)

  const [searchClientListFilter, setSearchClientListFilter] = useState("");
  const [columnCashflowListSorter, setColumnCashflowListSorter] = useState({ column: 'month', state: 'ASC' });

  const [contentPerPage, setContentPerPage] = useState(13)

  const [projectInprogressList, setProjectInprogressList] = useState([]);
  const [projectInprogressListCount, setProjectInprogressListCount] = useState(0);
  const [projectInprogressListPerPage, setProjectInprogressListPerPage] = useState(10);
  const [activeProjectInprogressListPage, setActiveProjectInprogressListPage] = useState(1);
  const [searchProjectInprogressListFilter, setSearchProjectInprogressListFilter] = useState("");
  const [columnProjectInprogressListSorter, setColumnProjectInprogressListSorter] = useState({ column: "createdAt", state: "desc" });
  
  const [projectDoneList, setProjectDoneList] = useState([]);
  const [projectDoneListCount, setProjectDoneListCount] = useState(0);
  const [projectDoneListPerPage, setProjectDoneListPerPage] = useState(10);
  const [activeProjectDoneListPage, setActiveProjectDoneListPage] = useState(1);
  const [searchProjectDoneListFilter, setSearchProjectDoneListFilter] = useState("");
  const [columnProjectDoneListSorter, setColumnProjectDoneListSorter] = useState({ column: "createdAt", state: "desc" });

  const columnProjects = columnProjectList?.filter(col => col.key !== 'value' && col.key !== 'tax_value' && col.key !== 'start_date' && col.key !== 'end_date' && col.key !== 'action' && col.key !== 'createdAt');

  const generalSetting = JSON.parse(localStorage.getItem("general_setting"))

  const maxForeverYear = generalSetting?.max_forever_year || 1

  useEffect(() => {
    let queries = {
      search: searchClientListFilter,
      limit: 10,
      offset: 0,
    };
    queries = formUrlQuery(queries);
    if (searchClientListFilter) {
      fetchAllClient(queries)
    } else {
      setClientOptions([])
    }
  }, [
    searchClientListFilter
  ])

  useEffect(() => {
    let queries = {};
    if (startDateValue && endDateValue) {
      queries = {
        ...queries,
        start_date: startDateValue,
        end_date: endDateValue
      }

      calculateContentPage(startDateValue, endDateValue)
    }
    if (clientValue?.value) {
      queries.client_id = clientValue?.value
    }
    if (periodValue?.value) {
      queries.period = periodValue?.value
    }
    if (columnCashflowListSorter.column) {
      queries.sort = (columnCashflowListSorter &&
          `${columnCashflowListSorter.column}%${columnCashflowListSorter.state}`) ||
        ""
    }
    queries = formUrlQuery(queries);
    fetchCountDashboard(queries);
  }, [
    startDateValue,
    endDateValue,
    clientValue,
    periodValue,
    columnCashflowListSorter
  ])

  useEffect(() => {
    let queries = {
      search: searchProjectInprogressListFilter,
      limit: projectInprogressListPerPage,
      offset: projectInprogressListPerPage * activeProjectInprogressListPage - projectInprogressListPerPage,
      sort:
        (columnProjectInprogressListSorter &&
          `${columnProjectInprogressListSorter.column}%${columnProjectInprogressListSorter.state}`) ||
        "",
      status: 'inprogress'
    };
    if (clientValue?.value) {
      queries.client_id = clientValue?.value
    }
    if (periodValue?.value) {
      queries.period = periodValue?.value
    }
    if (startDateValue && endDateValue) {
      queries = {
        ...queries,
        start_date: startDateValue,
        end_date: endDateValue
      }
    }
    queries = formUrlQuery(queries);
    fetchAllProjectsInprogress(queries);
  }, [
    searchProjectInprogressListFilter,
    projectInprogressListPerPage,
    activeProjectInprogressListPage,
    columnProjectInprogressListSorter,
    clientValue,
    periodValue,
    startDateValue,
    endDateValue
  ]);

  useEffect(() => {
    let queries = {
      search: searchProjectDoneListFilter,
      limit: projectDoneListPerPage,
      offset: projectDoneListPerPage * activeProjectDoneListPage - projectDoneListPerPage,
      sort:
        (columnProjectDoneListSorter &&
          `${columnProjectDoneListSorter.column}%${columnProjectDoneListSorter.state}`) ||
        "",
      status: 'done'
    };
    if (clientValue?.value) {
      queries.client_id = clientValue?.value
    }
    if (periodValue?.value) {
      queries.period = periodValue?.value
    }
    if (startDateValue && endDateValue) {
      queries = {
        ...queries,
        start_date: startDateValue,
        end_date: endDateValue
      }
    }
    queries = formUrlQuery(queries);
    fetchAllProjectsDone(queries);
  }, [
    searchProjectDoneListFilter,
    projectDoneListPerPage,
    activeProjectDoneListPage,
    columnProjectDoneListSorter,
    clientValue,
    periodValue,
    startDateValue,
    endDateValue
  ]);

  const fetchCountDashboard = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/dashboard/count?${queries}`
    })
      .then(({ data }) => {
        if (data?.success) {
          setDashboardCount(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const fetchAllClient = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/client?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setClientOptions(singleClientsOptionsSelect(data.value))
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchAllProjectsInprogress = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/project?${queries}`
    })
      .then(({ data }) => {
        const tempProjectList = data?.value?.map((d) => ({
          ...d,
          client_name: d?.client?.name
        }));
        setProjectInprogressList(tempProjectList);
        if (activeProjectInprogressListPage === 1) {
          setProjectInprogressListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchAllProjectsDone = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/project?${queries}`
    })
      .then(({ data }) => {
        const tempProjectList = data?.value?.map((d) => ({
          ...d,
          client_name: d?.client?.name
        }));
        setProjectDoneList(tempProjectList);
        if (activeProjectDoneListPage === 1) {
          setProjectDoneListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleOnDateChange = (value, name) => {
    if (name === 'start_date') {
      if (value) {
        setStartDateValue(moment(value).format('YYYY-MM-DD'))
        setPeriodValue(null)
      } else {
        setStartDateValue(null)
      }
    }

    if (name === 'end_date') {
      if (value) {
        setEndDateValue(moment(value).format('YYYY-MM-DD'))
        setPeriodValue(null)
      } else {
        setEndDateValue(null)
      }
    }
  }

  const handleSelectClient = (e) => {
    setClientValue(e)
  }

  const handleSelectPeriod = (e) => {
    setPeriodValue(e)
    setStartDateValue(null)
    setEndDateValue(null)
  }

  const handleSearchClient = (e) => {
    setSearchClientListFilter(e)
  }

  const calculateContentPage = (startDate, endDate) => {
    let totalMonth = moment(endDate).diff(moment(startDate), 'months') + 1

    setContentPerPage(totalMonth)
  }

  const handleSearchProjectInprogress = (search) => {
    setActiveProjectInprogressListPage(1)
    setSearchProjectInprogressListFilter(search);
  }

  const handleSearchProjectDone = (search) => {
    setActiveProjectDoneListPage(1)
    setSearchProjectDoneListFilter(search);
  }

  const handleOnRowProjectInprogressClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/project/details/${item.id}`)
    }
  }

  const handleOnRowProjectDoneClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/project/details/${item.id}`)
    }
  }

  return (
    <CContainer className='px-5 py-3'>
      <h2>Dashboard</h2>
      <CRow className='my-5 gap-3'>
        <CCol className='py-2'>
          <FormDatePicker 
            id='start_date'
            name='start_date'
            colSize='12'
            inputLabel='Filter start date'
            className='mb-2'
            value={startDateValue}
            handleOnDateChange={(e) => handleOnDateChange(e, 'start_date')}
            invalid={!startDateValue && endDateValue}
            feedbackInvalid={!startDateValue && endDateValue ? 'Please select filter start date' : ''}
            maxDate={moment(new Date()).add(maxForeverYear, 'year').subtract(1, 'day').format('YYYY-MM-DD')}
          />
        </CCol>
        <CCol className='py-2'>
          <FormDatePicker 
            id='end_date'
            name='end_date'
            colSize='12'
            inputLabel='Filter end date'
            className='mb-2'
            value={endDateValue}
            handleOnDateChange={(e) => handleOnDateChange(e, 'end_date')}
            invalid={startDateValue && !endDateValue}
            feedbackInvalid={startDateValue && !endDateValue ? 'Please select filter end date' : ''}
            minDate={startDateValue}
            maxDate={moment(new Date()).add(maxForeverYear, 'year').format('YYYY-MM-DD')}
          />
        </CCol>
        <CCol className='py-2'>
          <FormSelectInput 
            id='period'
            name='period'
            colSize='12'
            inputLabel='Filter by period'
            selectOptions={singlePeriodOptionSelect()}
            value={periodValue}
            handleSelectInput={handleSelectPeriod}
            disabled={false}
          />
        </CCol>
        <CCol className='py-2'>
          <FormSelectInput 
            id='client_value'
            name='client_value'
            colSize='12'
            inputLabel='Client name'
            selectOptions={clientOptions}
            value={clientValue}
            handleSelectInput={handleSelectClient}
            handleSearchInput={handleSearchClient}
            disabled={false}
            isDetectSearch={true}
          />
        </CCol>
      </CRow>
      <CRow className='mt-3 gap-5'>
        <CCol className='border border-black border-3 px-3 py-2'>
          <CCol className='mb-2'>
            Total Revenue
          </CCol>
          <CCol>
            IDR {dashboardCount?.total_revenue ? convertMoney(dashboardCount?.total_revenue) : '0'}
          </CCol>
        </CCol>
        <CCol className='border border-black border-3 px-3 py-2'>
          <CCol className='mb-2'>
            Total Profit
          </CCol>
          <CCol>
            IDR {dashboardCount?.total_profit ? convertMoney(dashboardCount?.total_profit) : '0'}
          </CCol>
        </CCol>
        <CCol className='border border-black border-3 px-3 py-2'>
          <CCol className='mb-2'>
            Total Expense
          </CCol>
          <CCol>
            IDR {dashboardCount?.total_expense > 0 ? convertMoney(dashboardCount?.total_expense) : '0'}
          </CCol>
        </CCol>
      </CRow>
      <CRow className='mt-3 gap-5'>
        <CCol className='border border-black border-3 px-3 py-2'>
          <CCol className='mb-2'>
            Total Payroll
          </CCol>
          <CCol>
            IDR {dashboardCount?.total_payroll > 0 ? convertMoney(dashboardCount?.total_payroll) : '0'}
          </CCol>
        </CCol>
        <CCol className='border border-black border-3 px-3 py-2'>
          <CCol className='mb-2'>
            Total Clients
          </CCol>
          <CCol>
            {dashboardCount?.total_client || 0}
          </CCol>
        </CCol>
        <CCol className='border border-black border-3 px-3 py-2'>
          <CCol className='mb-2'>
            Total Employees
          </CCol>
          <CCol>
            {dashboardCount?.total_employee || 0}
          </CCol>
        </CCol>
      </CRow>
      <CRow className='mt-5'>
        <span className='mb-2'><b>Cashflow position</b></span>
        <AppTable 
          tableColumns={columnCashflowPositionList}
          tableContent={dashboardCount?.cashflow_positions}
          isShowPagination={false}
          contentPerPage={contentPerPage}
          setContentPerPage={calculateContentPage}
          setColumnContentSorter={setColumnCashflowListSorter}
        />
      </CRow>
      <CRow className='mt-3 gap-2'>
        <span><b>Project status</b></span>
        <CCol className='border border-black border-3 p-3'>
          <CBadge color="warning" className='mb-3 p-2'>Inprogress</CBadge>
          <AppTable
            projectListPage
            tableFilter
            tableColumns={columnProjects}
            tableContent={projectInprogressList}
            contentPerPage={projectInprogressListPerPage}
            activeContentPage={activeProjectInprogressListPage}
            contentCount={projectInprogressListCount}
            searchContentFilter={searchProjectInprogressListFilter}
            setActiveContentPage={setActiveProjectInprogressListPage}
            setSearchContentFilter={handleSearchProjectInprogress}
            setContentPerPage={setProjectInprogressListPerPage}
            setColumnContentSorter={setColumnProjectInprogressListSorter}
            handleOnRowClick={handleOnRowProjectInprogressClick}
            isClickable={true}
          />
        </CCol>
        <CCol className='border border-black border-3 p-3'>
          <CBadge color="success" className='mb-3 p-2'>Done</CBadge>
          <AppTable
            projectListPage
            tableFilter
            tableColumns={columnProjects}
            tableContent={projectDoneList}
            contentPerPage={projectDoneListPerPage}
            activeContentPage={activeProjectDoneListPage}
            contentCount={projectDoneListCount}
            searchContentFilter={searchProjectDoneListFilter}
            setActiveContentPage={setActiveProjectDoneListPage}
            setSearchContentFilter={handleSearchProjectDone}
            setContentPerPage={setProjectDoneListPerPage}
            setColumnContentSorter={setColumnProjectDoneListSorter}
            handleOnRowClick={handleOnRowProjectDoneClick}
            isClickable={true}
          />
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default Dashboard